/**
 * AJ Lead Capture — bottom-right toast surface.
 *
 * Non-modal: no focus trap, no scrim, no scroll lock. Dismiss via the close
 * button only (clicking outside does nothing).
 *
 * @module toast
 */

import { buildCard } from './markup';

/**
 * Open a toast for an offer.
 *
 * @param {Object}   offer            Offer config.
 * @param {Object}   [opts]           Options.
 * @param {Function} [opts.onSubmit]  Submit handler(email) -> Promise.
 * @param {Function} [opts.onClose]   Called after the toast closes.
 * @returns {{close: Function, root: HTMLElement}}
 */
export function openToast(offer, opts = {}) {
  const region = document.createElement('div');
  region.className = 'aj-lo-toast';
  region.setAttribute('role', 'region');
  region.setAttribute('aria-label', 'Email signup');

  let closed = false;

  const close = () => {
    if (closed) {
      return;
    }
    closed = true;
    region.remove();
    document.body.classList.remove('aj-lo-toast-open');
    if (opts.onClose) {
      opts.onClose();
    }
  };

  const card = buildCard(offer, {
    showClose: true,
    onClose: close,
    onSubmit: opts.onSubmit,
  });

  region.appendChild(card.root);
  document.body.appendChild(region);
  // Lets other bottom-corner widgets (aj-toaster) step aside; see styles.css.
  document.body.classList.add('aj-lo-toast-open');

  return { close, root: region };
}
